// extracted by mini-css-extract-plugin
module.exports = {"commentList":"_3Z-pR","separator":"vyZpz"};